import { PageHero } from "@/components/public/Shared";
import { Target, Zap, Radio, Users, Eye, ShieldCheck, ArrowDown } from "lucide-react";

const GOALS = [
  { icon: Eye, t: "Meningkatkan Akses Informasi", d: "Informasi Bawaslu mudah diakses masyarakat kapan saja." },
  { icon: Zap, t: "Mempercepat Komunikasi Publik", d: "Respon cepat dan terintegrasi dalam satu kanal." },
  { icon: Target, t: "Meningkatkan Responsivitas", d: "Aspirasi masyarakat ditindaklanjuti secara terukur." },
  { icon: Radio, t: "Memperkuat Hubungan Media", d: "Layanan media center untuk kebutuhan publikasi." },
  { icon: Users, t: "Meningkatkan Partisipasi", d: "Mendorong pengawasan partisipatif masyarakat." },
  { icon: ShieldCheck, t: "Meningkatkan Transparansi", d: "Keterbukaan informasi memperkuat kepercayaan publik." },
];

const FLOW = ["Sumber Informasi", "Verifikasi", "Pengelolaan Humas", "Approval", "HARMONI BAWASLU", "Masyarakat / Media / Komunitas", "Feedback", "Monitoring & Evaluasi"];

export default function Tentang() {
  return (
    <div>
      <PageHero eyebrow="Tentang" title="Tentang HARMONI BAWASLU"
        description="Hubungan, Akses, Responsif, Media, dan Informasi Bawaslu — rencana aksi perubahan penguatan komunikasi publik Bawaslu Provinsi Sulawesi Tenggara." />
      <div className="container-page py-12">
        <div className="max-w-3xl">
          <p className="text-lg text-slate-600 leading-relaxed">
            <strong className="text-navy">HARMONI BAWASLU</strong> merupakan rencana aksi perubahan dalam penguatan komunikasi publik pada Sekretariat Bawaslu Provinsi Sulawesi Tenggara, khususnya dalam penguatan fungsi Hukum, Humas, dan Data Informasi.
          </p>
          <p className="text-slate-600 leading-relaxed mt-4">
            Melalui konsep "Satu Pintu Komunikasi Publik", HARMONI mengintegrasikan seluruh layanan informasi, publikasi, aspirasi, media, edukasi, dan monitoring dalam satu platform digital yang terpercaya dan mudah digunakan masyarakat.
          </p>
        </div>

        <h2 className="text-2xl font-extrabold text-navy mt-14 mb-6">Tujuan HARMONI</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {GOALS.map((g) => (
            <div key={g.t} className="bg-white border border-slate-200 rounded-xl p-6">
              <div className="h-12 w-12 rounded-xl bg-brandred/10 text-brandred flex items-center justify-center mb-3"><g.icon className="h-6 w-6" /></div>
              <h3 className="font-bold text-navy">{g.t}</h3>
              <p className="text-sm text-slate-500 mt-1.5">{g.d}</p>
            </div>
          ))}
        </div>

        <h2 className="text-2xl font-extrabold text-navy mt-16 mb-8 text-center">Alur Komunikasi Publik HARMONI</h2>
        <div className="max-w-md mx-auto flex flex-col items-center gap-0">
          {FLOW.map((f, i) => (
            <div key={f} className="w-full flex flex-col items-center">
              <div className={`w-full text-center rounded-xl py-3.5 px-4 font-bold ${f === "HARMONI BAWASLU" ? "bg-brandred text-white text-lg shadow-lg" : "bg-navy text-white"}`}>{f}</div>
              {i < FLOW.length - 1 && <ArrowDown className="h-6 w-6 text-slate-300 my-1.5" />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
